import React from "react";
import styled from "styled-components";

//Boostrap
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";

const DeactivateModal = ({ isOpen, toggle, isLoading, handleRemove, userName, isBulk }) => {
    return (
        <ModalStyled 
            isOpen={isOpen} 
            toggle={toggle} 
            backdrop={`static`} 
            centered
        >
            <ModalBody>
                <div className="modal-header-custom">
                    <div className="title-modal">Deactivate User</div>
                </div>
                <div className="mt-2">
                    Are you sure you want to deactivate this user? This will remove their access to the app.
                </div>
            </ModalBody>
            <ModalFooter>
                <Button className="btn btn-secondary" disabled={isLoading} onClick={toggle}>
                    Cancel
                </Button>{" "}
                <Button
                    className="btn btn-danger d-flex align-items-center"
                    onClick={() => handleRemove()}
                    disabled={isLoading || false}
                >
                    {isLoading && <span className="spinner-border spinner-border-sm mr-2"></span>}
                    Deactivate
                </Button>
            </ModalFooter>
        </ModalStyled>
    );
}

const ModalStyled = styled(Modal)`
    .modal-dialog {
        width: 512px;
        max-width: 512px;
        margin: 1.75rem auto;
    }
    
    .modal-content {
        width: 512px;
        border-radius: 8px;
    }
    
    .modal-body {
        padding: 16px 24px;
    }
    
    .modal-header-custom {
        margin-bottom: 12px;
    }
    
    .title-modal {
        font-size: 18px;
        font-weight: 600;
        color: #101828;
    }
    
    .modal-footer {
        border-top: 1px solid #E5E7EB;
        padding: 12px 24px;
        justify-content: flex-end;
    }
`;

export default DeactivateModal;

